angular.module('jv.MyAccount.Navigation.Ctrl', [])
.config(['$locationProvider', function($locationProvider){
    $locationProvider.hashPrefix('');
}])
    .controller('NavigationCtrl', ['$scope','$rootScope','$location', '$window', 'Navigation', function($scope,$rootScope,$location,$window, Navigation) {
        $scope.navigationItems = Navigation;
        var hashpath;
        var avilableApps={0:'FB',1:'LI',2:'TW',6:'GMAIL',30:'YAHOO',55:'GCALENDAR',53:'TALENT',59:'HIRE',75:'LINKEDIN_RSC', 72:'DOCUSIGN'};

        $scope.$on('$routeChangeSuccess', function () {

            var selectedTab = '';

            if($window.location.hash === '#/'){
                selectedTab = i18n['PROFILE'];
            }else if($window.location.hash.match('preferences')){
                selectedTab = i18n['PREFERENCES'];
            }else if($window.location.hash.match('notifications')){
                selectedTab = i18n['NOTIFICATIONS'];
            }else if($window.location.hash.match('authorizedApps')){
                selectedTab = i18n['AUTHAPPS'];
            } else if ($window.location.hash.match('emailTemplates')) {
                selectedTab = i18n['EMAIL_TEMPLATES'];
            } else if ($window.location.hash.match('jobAlerts')) {
                selectedTab = i18n['JOB_ALERTS'];
            }else if ($window.location.hash.match('linkedInRecruiter')) {
                selectedTab = i18n['LINKEDIN_RECRUITER'];
            }

            var queryStr = $location.url().split('?')[1] || '';
            hashpath = $location.path().split('/')[1] || 'profile';

            angular.forEach($scope.navigationItems,function(item){
                item.isCurrent = false;
                if(selectedTab === item.title){
                    item.isCurrent = true;
                    $rootScope.$broadcast('changeBreadCrumb',item.title);
                }
            });

            if(hashpath==='authorizedApps' && queryStr!==''){
                queryStr = queryStr.split('&');
                var result = {};
                angular.forEach(queryStr,function(pair) {
                    pair = pair.split('=');
                    result[pair[0]] = decodeURIComponent(pair[1] || '');
                });
                if(result.status==='true'){
                    $scope.showMsg(avilableApps[result.platform]+'_APP_CONNECTED');
                    /*
                     * Added this for https://jobvite.atlassian.net/browse/EN-2080
                     * After platform id is used to select the correct confirmation message,
                     * we would want to remove the platform information fron the URL
                     */
                    $location.url('/authorizedApps');
                }else{
                    $scope.showMsg('UNABLE_TO_CONNECT',false,'error');
                }
            }

            $rootScope.formOn=false;
            $rootScope.prev={};
            $rootScope.prevData={};
            $rootScope.prevReset={};
        });
    }]);
